/**
 * Comprehensive list of music-related professions for dropdown selection
 */
const professionsData = [
  // Performers
  'Musician', // Added general musician option
  'Vocalist',
  'Lead Singer',
  'Backing Vocalist',
  'DJ',
  'Electronic Music Producer',
  'Rapper',
  'Beatboxer',
  'Conductor',
  'Orchestra Member',
  'Band Member',
  'Solo Artist',
  'Street Performer',
  
  // Production & Technical
  'Music Producer',
  'Recording Engineer',
  'Mixing Engineer',
  'Mastering Engineer',
  'Sound Designer',
  'Sound Technician',
  'Live Sound Engineer',
  'Studio Manager',
  'Recording Studio Owner',
  'Audio Editor',
  'Foley Artist',
  'Music Programmer',
  'Beat Maker',
  'Sample Clearance Specialist',
  
  // Composition & Arrangement
  'Composer',
  'Songwriter',
  'Lyricist',
  'Arranger',
  'Orchestrator',
  'Film Score Composer',
  'Jingle Writer',
  'Music Transcriber',
  
  // Education & Coaching
  'Music Teacher',
  'Vocal Coach',
  'Instrument Instructor',
  'Music Professor',
  'Music Therapist',
  'Band Director',
  'Choir Director',
  'Music Director',
  'Minister of Music',
  'Music School Owner',
  
  // Business & Management
  'Artist Manager',
  'Booking Agent',
  'Music Promoter',
  'Tour Manager',
  'A&R Representative',
  'Music Publisher',
  'Music Supervisor',
  'Music Licensing Specialist',
  'Music Attorney',
  'Music Business Consultant',
  'Music Venue Manager',
  'Festival Organizer',
  'Record Label Owner',
  'Music Marketing Specialist',
  'Music Publicist',
  'Radio DJ',
  'Music Journalist',
  'Music Blogger',
  'Music Critic',
  
  // Other Music Professions
  'Music Librarian',
  'Instrument Maker',
  'Instrument Repair Technician',
  'Piano Tuner',
  'Music Archivist',
  'Music Historian',
  'Music Merchandise Designer',
  'Stage Manager',
  'Roadie',
  'Music Video Director',
];

export default professionsData;
